import get from 'lodash/get'
import {createSelector} from 'reselect'

export const getShippingAddress = (state) => get(state, 'addressUpdate.shippingAddress', {})
export const getShippingFirstName = (state) => get(state, 'addressUpdate.shippingAddress.firstName')
export const getShippingLastName = (state) => get(state, 'addressUpdate.shippingAddress.lastName')

export const isSaveShippingPending = createSelector(getShippingAddress, (address) =>
  get(address, 'isPending', false),
)

export const formattedShippingAddress = (formSectionName) =>
  createSelector(getShippingAddress, (address) => ({
    [formSectionName]: {
      address: {...address},
    },
  }))
